import { memo } from 'react';
import { Link } from 'react-router-dom'
import { Modal, Button } from '@ocean-club/ui'
import { t, T } from '@ocean-club/dapps/dist/modules/translation/utils'
import { locations } from '../../modules/routing/locations'
// import { getContract } from '../../modules/contract/utils'
import { isAuthorized } from '../SettingsPage/Authorization/utils'
import { Authorization } from '../SettingsPage/Authorization'
import { Props } from './AuthorizationModal.types'

const AuthorizationModal = (props: Props) => {
  const {
    open,
    authorization,
    authorizations,
    isLoading,
    isAuthorizing,
    onCancel,
    onProceed
  } = props

  // const contract = getContract({
  //   address: authorization.authorizedAddress
  // })
  // const token = getContract({
  //   address: authorization.contractAddress
  // })

  console.log('address: ' + authorization.address)
  console.log('contract address: ' + authorization.contractAddress)
  console.log('authorized address: ' + authorization.authorizedAddress)

  return (
    <Modal open={open} size="small" className="AuthorizationModal">
      <Modal.Header>
        {t('authorization_modal.title', {
          // token: token.name
          token: 'Tpunks Dex'
        })}
      </Modal.Header>
      <Modal.Description>
        <T
          id="authorization_modal.description"
          values={{
            contract: 'Tpunks Dex',
            token: 'Tpunks',
            settings_link: (
              <Link to={locations.settings()}>{t('global.settings')}</Link>
            ),
            br: (
              <>
                <br />
                <br />
              </>
            )
          }}
        />
      </Modal.Description>
      <Modal.Content>
        <Authorization
          key={authorization.authorizedAddress}
          authorization={authorization}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>{t('global.cancel')}</Button>
        <Button
          primary
          loading={isLoading}
          disabled={
            isLoading ||
            isAuthorizing ||
            !isAuthorized(authorization, authorizations)
          }
          onClick={onProceed}
        >
          {t('global.proceed')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default memo(AuthorizationModal)
